import React from "react";
import Link from "./Link";
import { Row, Col, Container } from "react-bootstrap";
import ContainerWide from "./ContainerWide";

import { newsinsCompData } from "../data/components-newsandinsights.data";

import SectionHeader from "./SectionHeader";
import ButtonText from "./ButtonText";

const NewsAndInsights = ({ header, text, link }) => {
    const compData = newsinsCompData();

    const articles = compData.allWpPost.nodes
        .filter((post) => {
            return compData.allSitePage.nodes.find(
                (sitePage) => sitePage.context.id === post.id
            );
        })
        .map((post) => {
            const localPage = compData.allSitePage.nodes.find(
                (sitePage) => sitePage.context.id === post.id
            );
            return {
                id: post.id,
                category: post.categories.nodes[0].name,
                date: post.date,
                title: post.title,
                url: localPage.path,
            };
        });

    const displayHeader =
        header || compData.wp.mdaThemeOptions.themeSettings.newsinsHeader;
    const displayText =
        text || compData.wp.mdaThemeOptions.themeSettings.newsinsText;
    const displayLink =
        link || compData.wp.mdaThemeOptions.themeSettings.newsinsLink;

    return (
        <section className="news-and-insights" id="news-and-insights">
            <Container>
                {displayHeader && (
                    <Row className="news-and-insights__title-row">
                        <Col>
                            <h2
                                className="news-and-insights__title"
                                dangerouslySetInnerHTML={{
                                    __html: displayHeader,
                                }}
                            />
                        </Col>
                    </Row>
                )}
                {displayText && (
                    <Row className="news-and-insights__subtitle-row">
                        <Col>
                            <p className="news-and-insights__subtitle">
                                {displayText}
                            </p>
                        </Col>
                    </Row>
                )}
                <Row className="news-and-insights__cards-row">
                    {articles.map((article, index) => (
                        <Col key={index} xs={24} lg={8}>
                            <NewsAndInsightsCard {...article} />
                        </Col>
                    ))}
                </Row>
                {displayLink && (
                    <Row className="news-and-insights__footer-row">
                        <Col>
                            <ButtonText
                                {...displayLink}
                                className="news-and-insights__button"
                                variant="red"
                            >
                                {displayLink?.title}
                            </ButtonText>
                        </Col>
                    </Row>
                )}
            </Container>
        </section>
    );
};

const NewsAndInsightsCard = ({ category, date, title, url, ...props }) => {
    const CardTag = url ? Link : "div";
    const cardProps = url ? { to: url } : {};

    return (
        <CardTag className="news-and-insights__card" {...cardProps} {...props}>
            <div className="news-and-insights__card-content">
                <h3 className="news-and-insights__link">{title}</h3>

                <div className="news-and-insights__card-meta">
                    <div className="news-and-insights__date">{date}</div>
                </div>
            </div>

            <div className="news-and-insights__card-notch">
                <span className="news-and-insights__action-button">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="7" y1="17" x2="17" y2="7"></line>
                        <polyline points="7 7 17 7 17 17"></polyline>
                    </svg>
                </span>
            </div>
        </CardTag>
    );
};

export default NewsAndInsights;
